import { Controller } from '@hotwired/stimulus';
import { ModalDialogController } from '@elc-online/edl-components/js/modal_dialog';

export default class extends Controller {
  static readonly targets = ['dialog', 'trigger', 'close'];

  declare dialogTarget: HTMLDialogElement;
  declare triggerTarget: HTMLElement;
  declare closeTarget: HTMLButtonElement;
  declare hasTriggerTarget: boolean;
  declare hasCloseTarget: boolean;

  private edlController?: ModalDialogController;

  initialize(): void {
    const config: any = {
      dialog: this.dialogTarget,
    };

    if (this.hasTriggerTarget) {
      config.trigger = this.triggerTarget;
    }

    if (this.hasCloseTarget) {
      config.close = this.closeTarget;
    }

    this.edlController = new ModalDialogController(config, { mode: 'auto' });
  }

  close = () => {
    this?.edlController?.close();
  };
}
